const BASE_ID = 100000;

export const PATIENT_TYPE = {
    neonatal: 'NEONATAL',
    pediatric: 'PEDIATRIC',
    adult: 'ADULT',
}

export const ALARM_PRIORITY = {
    high: 1,
    medium: 2,
    low: 3,
}

export const PARAMETER_UNIT_IDS = {
    [BASE_ID + 3501]: { UNIT: "-" },                     // unitless
    [BASE_ID + 3502]: { UNIT: "%" },                    // percentage
    [BASE_ID + 3503]: { UNIT: "cmH₂O" },                // cmH2O
    [BASE_ID + 3504]: { UNIT: "cmH₂O/L" },              // cmH2O per L
    [BASE_ID + 3505]: { UNIT: "cmH₂O/(L/s)" },          // cmH2O per L per sec
    [BASE_ID + 3506]: { UNIT: "bpm" },                  // breaths per minute
    [BASE_ID + 3507]: { UNIT: "bpm/L" },                // bpm per L
    [BASE_ID + 3508]: { UNIT: "mL" },                   // milliliters
    [BASE_ID + 3509]: { UNIT: "mL/cmH₂O" },             // mL per cmH2O
    [BASE_ID + 3510]: { UNIT: "mL/kg" },                // mL per kg
    [BASE_ID + 3511]: { UNIT: "mL/min" },               // mL per minute
    [BASE_ID + 3512]: { UNIT: "L/min" },                // liters per minute
    [BASE_ID + 3513]: { UNIT: "s" },                    // seconds
    [BASE_ID + 3514]: { UNIT: "mJ" },                   // milliJoules
    [BASE_ID + 3515]: { UNIT: "mmHg" },                 // millimeters of mercury
    [BASE_ID + 3516]: { UNIT: "%/L" },                  // percentage per L
    [BASE_ID + 3517]: { UNIT: "kcal/day" },             // kilocalories per day
};

export const SET_PARAMETERS = {
    [BASE_ID + 501]: {
        key: 'fio2',
        TITLE: 'FiO₂',
    },
    [BASE_ID + 502]: {
        key: 'peep',
        TITLE: 'PEEP',
    },
    [BASE_ID + 503]: {
        key: 'rr',
        TITLE: 'RR',
    },
    [BASE_ID + 504]: {
        key: 'pc_above_peep',
        TITLE: 'P₍insp₎ abv PEEP',
    },
    [BASE_ID + 506]: {
        key: 'i_e',
        TITLE: 'I:E',
    },
    [BASE_ID + 507]: {
        key: 't_rise',
        TITLE: 'T₍rise₎',
    },
    [BASE_ID + 508]: {
        key: 'trigger_sensitivity',
        TITLE: 'Trigger Sensitivity',
    },
    [BASE_ID + 509]: {
        key: 'ps_above_peep',
        TITLE: 'PS₍abv₎ PEEP',
    },
    [BASE_ID + 510]: {
        key: 'end_insp',
        TITLE: 'End Insp',
    },
    [BASE_ID + 511]: {
        key: 'tidal_volume',
        TITLE: 'VT',
    },
    [BASE_ID + 512]: {
        key: 't_pause',
        TITLE: 'T₍pause₎',
    },
    [BASE_ID + 513]: {
        key: 'slope_value',
        TITLE: 'Flow Slope',
    },
    [BASE_ID + 514]: {
        key: 'sync_window',
        TITLE: 'Sync₍window₎',
    },
    [BASE_ID + 515]: {
        key: 'apnea_time',
        TITLE: 'Apnea Time',
    },
    [BASE_ID + 516]: {
        key: 'plow',
        TITLE: 'P₍low₎',
    },
    [BASE_ID + 517]: {
        key: 'phigh',
        TITLE: 'P₍high₎',
    },
    [BASE_ID + 518]: {
        key: 'tlow',
        TITLE: 'T₍low₎',
    },
    [BASE_ID + 519]: {
        key: 'thigh',
        TITLE: 'T₍high₎',
    },
    [BASE_ID + 520]: {
        key: 'ps_above_phigh',
        TITLE: 'PS abv P₍high₎',
    },
    [BASE_ID + 521]: {
        key: 'ps_above_plow',
        TITLE: 'PS abv P₍low₎',
    },
    [BASE_ID + 522]: {
        key: 'flow_rate',
        TITLE: 'Flow Rate',
    },
    [BASE_ID + 523]: {
        key: 'flow_pattern',
        TITLE: 'Flow Pattern',
    },
    [BASE_ID + 524]: {
        key: 'cpap_peep',
        TITLE: 'PEEP',
    },
    [BASE_ID + 525]: {
        key: 'cpap_end_insp',
        TITLE: 'End Insp',
    },
    [BASE_ID + 526]: {
        key: 'cpap_t_rise',
        TITLE: 'T₍rise₎',
    },
    [BASE_ID + 527]: {
        key: 'epap',
        TITLE: 'EPAP',
    },
    [BASE_ID + 528]: {
        key: 'ipap',
        TITLE: 'IPAP',
    },
    [BASE_ID + 529]: {
        key: 't_insp',
        TITLE: 'Ti',
    },
    [BASE_ID + 530]: {
        key: 'i',
        TITLE: 'I',
    },
    [BASE_ID + 531]: {
        key: 'e',
        TITLE: 'E',
    },
    [BASE_ID + 532]: {
        key: 'pressure_trigger',
        TITLE: 'Pressure Trigger',
    },
    [BASE_ID + 533]: {
        key: 'flow_trigger',
        TITLE: 'Flow Trigger',
    },
};

export const ACTIVE_PARAMETERS = {
    // Monitor parameters (4001 - 4039)
    [BASE_ID + 4001]: { key: 'fio2', TITLE: 'FiO₂', fontColour: '#FFFFFF' },
    [BASE_ID + 4002]: { key: 'pip', TITLE: 'PIP', fontColour: '#3ADAE5' },
    [BASE_ID + 4003]: { key: 'peep', TITLE: 'PEEP', fontColour: '#3ADAE5' },
    [BASE_ID + 4004]: { key: 'rr', TITLE: 'RR', fontColour: '#FCC331' },
    [BASE_ID + 4005]: { key: 'i_e', TITLE: 'I:E', fontColour: '#FCC331' },
    [BASE_ID + 4006]: { key: 'leakage_vt', TITLE: 'Leakage VT', fontColour: '#268D3D' },
    [BASE_ID + 4007]: { key: 'vti', TITLE: 'VTI', fontColour: '#268D3D' },
    [BASE_ID + 4008]: { key: 'vte', TITLE: 'VTE', fontColour: '#268D3D' },
    [BASE_ID + 4009]: { key: 'mve', TITLE: 'MVE', fontColour: '#268D3D' },
    [BASE_ID + 4010]: { key: 'mvi', TITLE: 'MVI', fontColour: '#268D3D' },
    [BASE_ID + 4011]: { key: 'mve_spont', TITLE: 'MVE Spont', fontColour: '#268D3D' },
    [BASE_ID + 4012]: { key: 'vte_spont', TITLE: 'VTE Spont', fontColour: '#268D3D' },
    [BASE_ID + 4013]: { key: 'flow_rate', TITLE: 'Flow Rate', fontColour: '#FFFFFF' },
    [BASE_ID + 4014]: { key: 'c_static', TITLE: 'C stat', fontColour: '#FFFFFF' },
    [BASE_ID + 4015]: { key: 'c_dynamic', TITLE: 'C dyn', fontColour: '#FFFFFF' },
    [BASE_ID + 4016]: { key: 'p_drive', TITLE: 'P drive', fontColour: '#FFFFFF' },
    [BASE_ID + 4017]: { key: 'rr_spont', TITLE: 'RR Spont', fontColour: '#FCC331' },
    [BASE_ID + 4018]: { key: 'pwob', TITLE: 'PWOB', fontColour: '#FFFFFF' },
    [BASE_ID + 4019]: { key: 'p01', TITLE: 'P0.1', fontColour: '#FFFFFF' },
    [BASE_ID + 4020]: { key: 'pmean', TITLE: 'Pmean', fontColour: '#3ADAE5' },
    [BASE_ID + 4021]: { key: 'ti', TITLE: 'Ti', fontColour: '#FCC331' },
    [BASE_ID + 4022]: { key: 'te', TITLE: 'Te', fontColour: '#FCC331' },
    [BASE_ID + 4023]: { key: 'ri', TITLE: 'Ri', fontColour: '#FFFFFF' },
    [BASE_ID + 4024]: { key: 're', TITLE: 'Re', fontColour: '#FFFFFF' },
    [BASE_ID + 4025]: { key: 'flow_ee', TITLE: 'Flow EE', fontColour: '#FFFFFF' },
    [BASE_ID + 4026]: { key: 'rsbi', TITLE: 'RSBI', fontColour: '#FFFFFF' },
    [BASE_ID + 4027]: { key: 'elastance', TITLE: 'Elastance', fontColour: '#FFFFFF' },
    [BASE_ID + 4028]: { key: 'tv_pbw', TITLE: 'TV PBW', fontColour: '#FFFFFF' },
    [BASE_ID + 4029]: { key: 'tv_bw', TITLE: 'TV BW', fontColour: '#FFFFFF' },
    [BASE_ID + 4030]: { key: 'tc_insp', TITLE: 'TC insp', fontColour: '#FFFFFF' },
    [BASE_ID + 4031]: { key: 'tc_exp', TITLE: 'TC exp', fontColour: '#FFFFFF' },
    [BASE_ID + 4032]: { key: 'wob_vent', TITLE: 'WOB vent', fontColour: '#FFFFFF' },
    [BASE_ID + 4033]: { key: 'wob_i', TITLE: 'WOB I', fontColour: '#FFFFFF' },
    [BASE_ID + 4034]: { key: 'stress_index', TITLE: 'Stress Index', fontColour: '#FFFFFF' },
    [BASE_ID + 4035]: { key: 'ti_spont_ttotal', TITLE: 'Ti Spont/Ttotal', fontColour: '#FCC331' },
    [BASE_ID + 4036]: { key: 'p_plateau', TITLE: 'P plat', fontColour: '#3ADAE5' },
    [BASE_ID + 4037]: { key: 'auto_peep', TITLE: 'Auto PEEP', fontColour: '#3ADAE5' },
    [BASE_ID + 4038]: { key: 'trapped_volume', TITLE: 'Trapped Volume', fontColour: '#268D3D' },
    [BASE_ID + 4039]: { key: 'pwb', TITLE: 'PWB', fontColour: '#FFFFFF' },

    // SPO2
    [BASE_ID + 4301]: { key: 'spo2', TITLE: 'SpO₂', fontColour: '#EF9A46' },
    [BASE_ID + 4302]: { key: 'pulse_rate', TITLE: 'Pulse Rate', fontColour: '#EF9A46' },
    [BASE_ID + 4303]: { key: 'perfusion_index', TITLE: 'PI', fontColour: '#EF9A46' },

    // Capnography
    [BASE_ID + 4401]: { key: 'fetco2', TITLE: 'FetCO₂', fontColour: '#5247E7' },
    [BASE_ID + 4402]: { key: 'petco2', TITLE: 'PetCO₂', fontColour: '#5247E7' },
    [BASE_ID + 4403]: { key: 'vtco2', TITLE: 'VtCO₂', fontColour: '#5247E7' },
    [BASE_ID + 4404]: { key: 'mvco2', TITLE: 'MVCO₂', fontColour: '#5247E7' },
    [BASE_ID + 4405]: { key: 'vdphys', TITLE: 'VDphys', fontColour: '#5247E7' },
    [BASE_ID + 4406]: { key: 'vdanat', TITLE: 'VDanat', fontColour: '#5247E7' },
    [BASE_ID + 4407]: { key: 'vdanat__vte', TITLE: 'VDanat/VTE', fontColour: '#5247E7' },
    [BASE_ID + 4408]: { key: 'vdalv', TITLE: 'VDalv', fontColour: '#5247E7' },
    [BASE_ID + 4409]: { key: 'vdalv__vte', TITLE: 'VDalv/VTE', fontColour: '#5247E7' },
    [BASE_ID + 4410]: { key: 'slopeco2', TITLE: 'Slope CO2', fontColour: '#5247E7' },
    [BASE_ID + 4411]: { key: 'vtalv', TITLE: 'VtAlv', fontColour: '#5247E7' },
    [BASE_ID + 4412]: { key: 'mvalv', TITLE: 'MVAlv', fontColour: '#5247E7' },
    [BASE_ID + 4413]: { key: 'vto2', TITLE: 'VtO₂', fontColour: '#5247E7' },
    [BASE_ID + 4414]: { key: 'ee', TITLE: 'EE', fontColour: '#5247E7' },
    [BASE_ID + 4415]: { key: 'rq', TITLE: 'RQ', fontColour: '#5247E7' },
    [BASE_ID + 4416]: { key: 'co2_gradient', TITLE: 'CO2 Gradient', fontColour: '#5247E7' },
    [BASE_ID + 4417]: { key: 'pao2', TITLE: 'PaO₂', fontColour: '#5247E7' },
    [BASE_ID + 4418]: { key: 'bgd_pao2__fio2', TITLE: 'PaO₂/FiO2', fontColour: '#5247E7' },
    [BASE_ID + 4419]: { key: 'bgd_pao2__pao2', TITLE: 'PaO₂/PaO2', fontColour: '#5247E7' },
    [BASE_ID + 4420]: { key: 'oi', TITLE: 'OI', fontColour: '#5247E7' },
    [BASE_ID + 4421]: { key: 'spo2__fio2', TITLE: 'SpO₂/FiO2', fontColour: '#EF9A46' },
    [BASE_ID + 4422]: { key: 'bgd_paco2', TITLE: 'PaCO₂', fontColour: '#5247E7' }
};



export const VENTILATOR_ADDITIONAL_FEATURES = {
    o2_boost: BASE_ID + 11001,
    o2_suction: BASE_ID + 11002,
    nif: BASE_ID + 11003,
    p01: BASE_ID + 11004,
    inspiratory_hold: BASE_ID + 11005,
    expiratory_hold: BASE_ID + 11006,
    aerogen_nebulizer: BASE_ID + 11007,
    pnumetic_nebulizer: BASE_ID + 11008,
    humidifier: BASE_ID + 11009,
    capnography: BASE_ID + 11010,
    audio_mute: BASE_ID + 11011,
    manual_breath: BASE_ID + 11012,
    leakage_compensation: BASE_ID + 11013,
    atc: BASE_ID + 11014,
    proximal_sensor: BASE_ID + 11015
};

export const MANEUVERS = {
    111001: {
        key: 'Inspiratory_hold',
        TITLE_START: 'Inspiratory Hold',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111002: {
        key: 'expiratory_hold',
        TITLE_START: 'Expiratory Hold',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111003: {
        key: 'o2_boost',
        TITLE_START: 'O',
        TITLE_SUB_SCRIPT: '2',
        TITLE_END: ' Boost',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111004: {
        key: 'suction_support',
        TITLE_START: 'Suction Support',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111005: {
        key: 'nif',
        TITLE_START: 'NIF',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111006: {
        key: 'p01',
        TITLE_START: 'P0.1',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111007: {
        key: 'manual_breath',
        TITLE_START: 'Manual Breath',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111008: {
        key: 'aerogen_nebulizer',
        TITLE_START: 'Ultrasonic Nebulizer',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    111009: {
        key: 'smart_humidifier',
        TITLE_START: 'Smart Humidifier',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
}

export const TEMP_PARAMETERS = {
    pip: {
        id: 1,
        TITLE_START: "PIP",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    ipap: {
        id: 1,
        TITLE_START: "IPAP",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    ppleatu: {
        id: 2,
        TITLE_START: "P",
        TITLE_SUB_SCRIPT: "plat",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    peep: {
        id: 3,
        TITLE_START: "PEEP",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    epap: {
        id: 3,
        TITLE_START: "EPAP",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    i_e: {
        id: 4,
        TITLE_START: "I:E",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    leakagevt: {
        id: 5,
        TITLE_START: "Leakage",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "%",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    vti: {
        id: 6,
        TITLE_START: "VT",
        TITLE_SUB_SCRIPT: "i",
        TITLE_END: '',
        UNIT_START: "ml",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    vte: {
        id: 7,
        TITLE_START: "VT",
        TITLE_SUB_SCRIPT: "e",
        TITLE_END: '',
        UNIT_START: "ml",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    rr: {
        id: 8,
        TITLE_START: "RR",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "b/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    fio2: {
        id: 9,
        TITLE_START: "FiO",
        TITLE_SUB_SCRIPT: "2",
        TITLE_END: '',
        UNIT_START: "%",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    mve: {
        id: 10,
        TITLE_START: "MV",
        TITLE_SUB_SCRIPT: "e",
        TITLE_END: '',
        UNIT_START: "l/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    mvi: {
        id: 11,
        TITLE_START: "MV",
        TITLE_SUB_SCRIPT: "i",
        TITLE_END: '',
        UNIT_START: "l/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    mvspont: {
        id: 12,
        TITLE_START: "MV",
        TITLE_SUB_SCRIPT: "e",
        TITLE_END: 'sp',
        UNIT_START: "l/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    vtspont: {
        id: 13,
        TITLE_START: "VT",
        TITLE_SUB_SCRIPT: "e",
        TITLE_END: 'sp',
        UNIT_START: "l",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    flowrate: {
        id: 14,
        TITLE_START: "Flow Rate",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "l/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    cstate: {
        id: 15,
        TITLE_START: "C",
        TITLE_SUB_SCRIPT: "stat",
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    cdyn: {
        id: 16,
        TITLE_START: "C",
        TITLE_SUB_SCRIPT: "dyn",
        TITLE_END: '',
        UNIT_START: "ml/cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    pdrive: {
        id: 17,
        TITLE_START: "P",
        TITLE_SUB_SCRIPT: "drive",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    rrspont: {
        id: 18,
        TITLE_START: "RR",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: 'sp',
        UNIT_START: "b/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    etco2: {
        id: 19,
        TITLE_START: "EtCO",
        TITLE_SUB_SCRIPT: "2",
        TITLE_END: '',
        UNIT_START: "%",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    spo2: {
        id: 20,
        TITLE_START: "SpO",
        TITLE_SUB_SCRIPT: "2",
        TITLE_END: '',
        UNIT_START: "%",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    pwob: {
        id: 21,
        TITLE_START: "WOBpat",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    p01: {
        id: 23,
        TITLE_START: "P0.1",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    pmean: {
        id: 24,
        TITLE_START: "P",
        TITLE_SUB_SCRIPT: "mean",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O'
    },
    ti: {
        id: 25,
        TITLE_START: "T",
        TITLE_SUB_SCRIPT: "i",
        TITLE_END: '',
        UNIT_START: "s",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    ri: {
        id: 26,
        TITLE_START: "R",
        TITLE_SUB_SCRIPT: "i",
        TITLE_END: '',
        UNIT_START: "b/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    te: {
        id: 27,
        TITLE_START: "T",
        TITLE_SUB_SCRIPT: "e",
        TITLE_END: '',
        UNIT_START: "s",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    flowee: {
        id: 28,
        TITLE_START: "Flow",
        TITLE_SUB_SCRIPT: "ee",
        TITLE_END: '',
        UNIT_START: "l/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    pluserate: {
        id: 29,
        TITLE_START: "PR",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "b/min",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    perfusionindex: {
        id: 30,
        TITLE_START: "PI",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    pleth: {
        id: 31,
        TITLE_START: "Pleth",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    rsbi: {
        id: 32,
        TITLE_START: "RSBI",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "b/min/l",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    elastance: {
        id: 33,
        TITLE_START: "E",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "cmH",
        UNIT_SUB_SCRIPT: "2",
        UNIT_END: 'O/l'
    },
    tvpbw: {
        id: 34,
        TITLE_START: "TV:PBW",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "ml/kg",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
    tvbw: {
        id: 35,
        TITLE_START: "TV:BW",
        TITLE_SUB_SCRIPT: "",
        TITLE_END: '',
        UNIT_START: "ml/kg",
        UNIT_SUB_SCRIPT: "",
        UNIT_END: ''
    },
}


export const TEMP_SET_PARAMETERS = {
    fio2: {
        TITLE_START: 'FiO',
        TITLE_SUB_SCRIPT: '2',
        TITLE_END: '',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    peep: {
        TITLE_START: 'PEEP',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    rr: {
        TITLE_START: 'RR',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 'b/min',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    pc_above_peep: {
        TITLE_START: 'P',
        TITLE_SUB_SCRIPT: 'insp',
        TITLE_END: ' abv PEEP',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    i_e: {
        TITLE_START: 'I:E',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: '',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    t_rise: {
        TITLE_START: 'T',
        TITLE_SUB_SCRIPT: 'rise',
        TITLE_END: '',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    ps_above_peep: {
        TITLE_START: 'PS abv',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: ' PEEP',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    end_insp: {
        TITLE_START: 'End Insp',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: ' ',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    tidal_volume: {
        TITLE_START: 'VT',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: ' ',
        UNIT_START: 'ml',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    t_pause: {
        TITLE_START: 'T',
        TITLE_SUB_SCRIPT: 'pause',
        TITLE_END: ' ',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    slope_value: {
        TITLE_START: 'Slope',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: ' ',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    sync_window: {
        TITLE_START: 'Sync window',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: ' ',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    apnea_time: {
        TITLE_START: 'Apnea Time',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: ' ',
        UNIT_START: 's',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    plow: {
        TITLE_START: 'P',
        TITLE_SUB_SCRIPT: 'low',
        TITLE_END: ' ',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    phigh: {
        TITLE_START: 'P',
        TITLE_SUB_SCRIPT: 'high',
        TITLE_END: ' ',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    tlow: {
        TITLE_START: 'T',
        TITLE_SUB_SCRIPT: 'low',
        TITLE_END: ' ',
        UNIT_START: 's',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    thigh: {
        TITLE_START: 'T',
        TITLE_SUB_SCRIPT: 'high',
        TITLE_END: ' ',
        UNIT_START: 's',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    ps_above_phigh: {
        TITLE_START: 'PS abv P',
        TITLE_SUB_SCRIPT: 'High',
        TITLE_END: '',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    ps_above_plow: {
        TITLE_START: 'PS abv P',
        TITLE_SUB_SCRIPT: 'Low',
        TITLE_END: '',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    flow_rate: {
        TITLE_START: 'Flow Rate',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 'l/min',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    flow_pattern: {
        TITLE_START: 'Flow Pattern',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: '',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    cpap_peep: {
        TITLE_START: 'PEEP',
        TITLE_SUB_SCRIPT: '/',
        TITLE_END: 'CPAP',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    cpap_end_insp: {
        TITLE_START: 'End Insp',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    cpap_t_rise: {
        TITLE_START: 'T',
        TITLE_SUB_SCRIPT: 'rise',
        TITLE_END: '',
        UNIT_START: '%',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    epap: {
        TITLE_START: 'EPAP',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    ipap: {
        TITLE_START: 'IPAP',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 'cmH',
        UNIT_SUB_SCRIPT: '2',
        UNIT_END: 'O'
    },
    t_insp: {
        TITLE_START: 'Ti',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 's',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    },
    trigger_senstivity: {
        TITLE_START: 'Trigger Sensitivity',
        TITLE_SUB_SCRIPT: '',
        TITLE_END: '',
        UNIT_START: 'l/min',
        UNIT_SUB_SCRIPT: '',
        UNIT_END: ''
    }
}

// export const VENTI_PAGE_TEMPLATE = {
//     [1]: [
//         BASE_ID + 4002, // pip
//         BASE_ID + 4020, // pmean
//         BASE_ID + 4036, // p_plateau
//         BASE_ID + 4003, // peep
//         BASE_ID + 4001, // fio2
//         BASE_ID + 4004, // rr
//         BASE_ID + 4005, // i_e
//         BASE_ID + 4017, // rr_spont
//         BASE_ID + 4008, // vte
//         BASE_ID + 4007, // vti
//         BASE_ID + 4006, // leakage_vt
//         BASE_ID + 4009, // mve
//         BASE_ID + 4010, // mvi
//         BASE_ID + 4011, // mve_spont
//     ],

//     [2]: [
//         BASE_ID + 4021, // ti
//         BASE_ID + 4022, // te
//         BASE_ID + 4035, // ti_spont_ttotal
//         BASE_ID + 4015, // c_dynamic
//         BASE_ID + 4026, // rsbi
//         BASE_ID + 4034, // stress_index
//         BASE_ID + 4014, // c_static
//         BASE_ID + 4023, // ri
//         BASE_ID + 4024, // re
//         BASE_ID + 4032, // wob_vent
//         BASE_ID + 4038, // trapped_volume
//         BASE_ID + 4037, // auto_peep
//         BASE_ID + 4031, // tc_exp
//         BASE_ID + 4030, // tc_insp
//         BASE_ID + 4025, // flow_ee
//     ],

//     [3]: [
//         BASE_ID + 4028, // tv_pbw
//         BASE_ID + 4029, // tv_bw
//         BASE_ID + 4039, //pwb
//         BASE_ID + 4401, // fetco2
//         BASE_ID + 4403, // vtco2
//         BASE_ID + 4404, // mvco2
//         BASE_ID + 4405, // vdphys
//         BASE_ID + 4409, // vdalv__vte
//         BASE_ID + 4407, // vdanat__vte
//         BASE_ID + 4410, // slopeco2
//         BASE_ID + 4411, // vtalv
//         BASE_ID + 4412, // mvalv
//         BASE_ID + 4402, // petco2
//         BASE_ID + 4408, // vdalv
//         BASE_ID + 4406, // vdanat
//     ],

//     [4]: [
//         BASE_ID + 4414, // ee
//         BASE_ID + 4415, // rq
//         BASE_ID + 4418, // bgd_pao2__fio2
//         BASE_ID + 4417, // pao2
//         BASE_ID + 4419, // bgd_pao2__pao2
//         BASE_ID + 4420, // oi
//         BASE_ID + 4001, // fio2
//         BASE_ID + 4413, // vto2
//         BASE_ID + 4421, // spo2__fio2
//         BASE_ID + 4006, // leakage_vt
//         BASE_ID + 4011, // mve_spont
//         BASE_ID + 4010, // mvi
//         BASE_ID + 4301, // spo2
//         BASE_ID + 4302, // pulse_rate
//         BASE_ID + 4303, // perfusion_index
//     ],
// };


export const VENTI_PAGE_TEMPLATE = {
    [1]: [
        BASE_ID + 4002, // pip
        BASE_ID + 4020, // pmean
        BASE_ID + 4036, // p_plateau
        BASE_ID + 4003, // peep
        BASE_ID + 4001, // fio2
        BASE_ID + 4004, // rr
        BASE_ID + 4005, // i_e
        BASE_ID + 4017, // rr_spont
        BASE_ID + 4008, // vte
        BASE_ID + 4007, // vti
        BASE_ID + 4006, // leakage_vt
        BASE_ID + 4009, // mve
        BASE_ID + 4010, // mvi
        BASE_ID + 4011, // mve_spont
    ],

    [2]: [
        BASE_ID + 4021, // ti
        BASE_ID + 4022, // te
        BASE_ID + 4035, // ti_spont_ttotal
        BASE_ID + 4015, // c_dynamic
        BASE_ID + 4026, // rsbi
        BASE_ID + 4034, // stress_index
        BASE_ID + 4014, // c_static
        BASE_ID + 4023, // ri
        BASE_ID + 4024, // re
        BASE_ID + 4032, // wob_vent
        BASE_ID + 4038, // trapped_volume
        BASE_ID + 4037, // auto_peep
        BASE_ID + 4031, // tc_exp
        BASE_ID + 4030, // tc_insp
        BASE_ID + 4025, // flow_ee
    ],

    [3]: [
        BASE_ID + 4028, // tv_pbw
        BASE_ID + 4029, // tv_bw
        BASE_ID + 4039, // pbw
        BASE_ID + 4401, // fetco2
        BASE_ID + 4403, // vtco2
        BASE_ID + 4404, // mvco2
        BASE_ID + 4405, // vdphys
        BASE_ID + 4409, // vdalv__vte
        BASE_ID + 4407, // vdanat__vte
        BASE_ID + 4410, // slopeco2
        BASE_ID + 4411, // vtalv
        BASE_ID + 4412, // mvalv
        BASE_ID + 4402, // petco2
        BASE_ID + 4408, // vdalv
        BASE_ID + 4406, // vdanat
    ],

    [4]: [
        BASE_ID + 4414, // ee
        BASE_ID + 4415, // rq
        BASE_ID + 4418, // bgd_pao2__fio2
        BASE_ID + 4417, // pao2
        BASE_ID + 4419, // bgd_pao2__pao2
        BASE_ID + 4420, // oi
        BASE_ID + 4001, // fio2
        BASE_ID + 4413, // vto2
        BASE_ID + 4421, // spo2__fio2
        BASE_ID + 4006, // leakage_vt
        BASE_ID + 4011, // mve_spont
        BASE_ID + 4010, // mvi
        BASE_ID + 4301, // spo2
        BASE_ID + 4302, // pulse_rate
        BASE_ID + 4303, // perfusion_index
    ],
};

